__turbopack_context__.v({
  "link": "localTimeZoneTip-module-scss-module__yOGckq__link",
});
